import { useTranslation } from 'react-i18next';
import Image from "../assets/webp/este.webp";
import Image1 from '../assets/webp/cardM1.webp';
import Image2 from '../assets/webp/cardM2.webp';
import Image3 from '../assets/webp/cardM3.webp';
import Image4 from '../assets/webp/cardM4.webp';

export default function CardsGrid() {
  const { t } = useTranslation();

  const cards = [
    {
      titulo: t('cardsGrid.cards.0.titulo'),
      contenido: t('cardsGrid.cards.0.contenido'),
      image: (
        <img
          src={Image1}
          alt="Gráfico"
          className="lg:w-[200px] bg-white w-3/5 sm:w-[100px] mb-4 animate-scale-infinite"
        />
      ),
    },
    {
      titulo: t('cardsGrid.cards.1.titulo'),
      contenido: t('cardsGrid.cards.1.contenido'),
      image: (
        <img
          src={Image2}
          alt="Gráfico"
          className="lg:w-[200px] bg-white w-3/5 sm:w-[100px] mb-4 animate-scale-infinite"
        />
      ),
    },
    {
      titulo: t('cardsGrid.cards.2.titulo'),
      contenido: t('cardsGrid.cards.2.contenido'),
      image: (
        <img
          src={Image3}
          alt="Gráfico"
          className="lg:w-[200px] bg-white w-3/5 sm:w-[100px] mb-4 animate-scale-infinite"
        />
      ),
    },
    {
      titulo: t('cardsGrid.cards.3.titulo'),
      contenido: t('cardsGrid.cards.3.contenido'),
      image: (
        <img
          src={Image4}
          alt="Gráfico"
          className="lg:w-[205px] bg-white w-3/5 sm:w-[100px] mb-4 animate-scale-infinite"
        />
      ),
    },
  ];

  // Tarjeta para la PRIMERA CARD (sin ancho fijo)
  const cardClassFirst = `
     rounded-[40px] 
    bg-[#FDDEF3] 
    shadow-[0px_4px_4px_rgba(0,0,0,0.25)]
    transform
    w-auto 
    max-w-[500px]
    h-auto 
    min-h-[200px] 
    max-h-[90vh]
    lg:p-12
    p-8
    flex
    flex-col
    items-center
    justify-center
    transition-transform
    duration-300
    hover:scale-105
  `;

  // Tarjetas para las OTRAS TRES (ancho fijo)
  const cardClass = `
    flex
    flex-col
    items-center
    justify-start
    mb:w-[300px]                 /* Fija un ancho definido */
    w-[500px]
    rounded-[40px]
    bg-[#FDDEF3]
    shadow-[0px_4px_4px_rgba(0,0,0,0.25)]
    p-8
    lg:p-12
    transform
    transition-transform
    duration-300
    hover:scale-105
  `;

  const imageClass = `
    rounded-t-[30px]
    p-4
    w-full
    bg-white
    mb-4
    flex
    items-center
    justify-center
  `;

  return (
    <section className="bg-white flex flex-col" id="cards">
      <div className="divider-conteiner text-center space-y-0 mb:space-y-2">
        <h1 className="font-sans text-secondary font-bold resp-h3">
          {t('cardsGrid.title')}
        </h1>
        <p className="hero-p resp-h2" style={{ lineHeight: "130%" }}>
          {t('cardsGrid.subtitle')}
        </p>
      </div>

      <div className="mx-auto">
        <div className="mb:p-8 p-16 grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* 
            FILA 1 (col-span-3):
            Izq: Bloque con Imagen "este.webp" + texto + botón 
            Der: 1ª tarjeta, que se adapta al contenido (sin ancho fijo).
          */}
          <div className="md:col-span-3 flex flex-col md:flex-row md:items-start md:justify-center items-center gap-8">
            {/* Lado Izquierdo */}
            <div className="max-w-[500px] m-4">
              <div className="flex items-center justify-center">
                <img
                  src={Image}
                  alt="Gráfico"
                  className="min-w-[200px] max-w-[300px] w-3/5 h-auto animate-zoom2"
                />
              </div>
              <div className="flex flex-col items-center justify-center">
                <h1 className="font-sans text-secondary font-bold resp-h3 mb:mb-4 mb:mt-1">
                  {t('cardsGrid.heroBlock.title')}
                </h1>
                <p
                  className="mb:text-h3 font-sans text-body5 break-words text-center mb-4"
                  style={{ color: "#555555", lineHeight: "130%" }}
                >
                  {t('cardsGrid.heroBlock.description')}
                </p>
                <button
                  className="font-archivo resp-h2 btn-secondary "
                  onClick={() => {
                    document
                      .getElementById("contacto")
                      .scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  {t('cardsGrid.heroBlock.btnContact')}
                </button>
              </div>
            </div>

            {/* Primera Tarjeta (cards[0]), sin ancho fijo */}
            <div className={cardClassFirst}>
              <div className={imageClass}>
                {cards[0].image}
                <style>
                  {`
                    @keyframes scale-infinite {
                      0%, 100% {
                        transform: scale(1);
                      }
                      50% {
                        transform: scale(1.05);
                      }
                    }
                    .animate-scale-infinite {
                      animation: scale-infinite 3s ease-in-out infinite;
                    }
                  `}
                </style>
              </div>
              <p className="text-center font-archivo break-words ft-title">
                {cards[0].titulo}
              </p>
              <p
                className="text-[14px] text-header2 text-sans ft-p break-words text-center"
                style={{ lineHeight: "150%" }}
              >
                {cards[0].contenido}
              </p>
            </div>
          </div>

          {/* 
            FILA 2 (col-span-3):
            Las 3 tarjetas restantes con ancho fijo y 'items-stretch'.
          */}
          <div className="md:col-span-3 flex flex-col md:flex-row md:items-stretch md:justify-center items-center gap-8">
            {/* Tarjeta 1 (cards[1]) */}
            <div className={cardClass}>
              <div className={imageClass}>{cards[1].image}</div>
              <p className="text-center font-archivo break-words ft-title">
                {cards[1].titulo}
              </p>
              <p
                className="text-[14px] text-header2 text-sans ft-p break-words text-center"
                style={{ lineHeight: "150%" }}
              >
                {cards[1].contenido}
              </p>
            </div>

            {/* Tarjeta 2 (cards[2]) */}
            <div className={cardClass}>
              <div className={imageClass}>{cards[2].image}</div>
              <p className="text-center font-archivo break-words ft-title">
                {cards[2].titulo}
              </p>
              <p
                className="text-[14px] text-header2 text-sans ft-p break-words text-center"
                style={{ lineHeight: "150%" }}
              >
                {cards[2].contenido}
              </p>
            </div>

            {/* Tarjeta 3 (cards[3]) */}
            <div className={cardClass}>
              <div className={imageClass}>{cards[3].image}</div>
              <p className="text-center font-archivo break-words ft-title">
                {cards[3].titulo}
              </p>
              <p
                className="text-[14px] text-header2 text-sans ft-p break-words text-center"
                style={{ lineHeight: "150%" }}
              >
                {cards[3].contenido}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
